module.exports = __webpack_public_path__ + "img/message-dollar.9fee3fec.svg";